<template>
  <div class="substep-control-time-tracking">
    <div class="substep-header">
      <h3 data-testId="step-title">You control how time is tracked</h3>
      <p>
        You have full control over idle time, manual entries, and privacy. These are our recommended
        defaults based on over <strong>10,000 teams like yours.</strong>
        <br>
        You can change these later in your workspace Settings.
      </p>
    </div>
    <div class="substep-body">
      <div
        v-for="card in settingCards"
        :key="card.icon"
        class="setting-card"
      >
        <div class="setting-card-header">
          <div class="setting-card-icon">
            <img
              :src="iconSrc(card.icon)"
              :alt="card.title"
            />
          </div>
          <div class="setting-card-heading">
            <div class="setting-card-title">{{ card.title }}</div>
            <div class="setting-card-description">{{ card.description }}</div>
          </div>
        </div>
        <div class="setting-card-recommended">
          <div class="setting-card-recommended-label">Recommended default</div>
          <div
            v-tooltip="{ placement: 'top' }"
            class="setting-card-recommended-badge"
            :title="recommendedBadgeTooltip"
          >
            {{ card.recommended_default }}
          </div>
        </div>
        <div class="setting-card-why">
          <div class="setting-card-why-label">Why this works:</div>
          <div class="setting-card-why-text">{{ card.why_this_works }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  VSMB_GETTING_STARTED_IDLE_TIME_ICON,
  VSMB_GETTING_STARTED_MANUAL_TIME_ICON,
  VSMB_GETTING_STARTED_SCREENSHOTS_ICON,
} from '~/rails_assets';

const SETTING_CARD_ICONS = {
  idle_time: VSMB_GETTING_STARTED_IDLE_TIME_ICON,
  manual_time: VSMB_GETTING_STARTED_MANUAL_TIME_ICON,
  screenshots: VSMB_GETTING_STARTED_SCREENSHOTS_ICON,
};

const RECOMMENDED_BADGE_TOOLTIP = "You can change this later in your organization's Settings page";

export default {
  name: 'ControlTimeTracking',
  props: {
    settingCards: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      recommendedBadgeTooltip: RECOMMENDED_BADGE_TOOLTIP,
    };
  },
  mounted() {
    this.$emit('completeSubstep');
  },
  methods: {
    iconSrc(icon) {
      return SETTING_CARD_ICONS[icon];
    },
  },
};
</script>
